// extracted by mini-css-extract-plugin
export default {"container":"select_container__WUT0E","form__select":"select_form__select__FZlKO"};